import { IVideo, PlayerType } from '../models/video';

export const getVideoConfig = (resolutionVideo: IVideo) => {
  const playerType = getPlayerType(resolutionVideo);
  const token = getVideoToken(playerType, resolutionVideo);

  return {
    playerType,
    token,
    hasToken: token !== '',
  };
};

const getPlayerType = (resolutionVideo: IVideo): PlayerType => {
  if (
    resolutionVideo?.defaultPlayer === 'youtube' ||
    (resolutionVideo?.player === 'youtube' && resolutionVideo?.youtubeUrl)
  ) {
    return 'youtube';
  }

  if (resolutionVideo?.vimeoID) {
    return 'vimeo';
  }

  if (
    resolutionVideo?.defaultPlayer === 'samba' ||
    resolutionVideo?.player === 'samba'
  ) {
    return 'sambatech';
  }

  return (
    resolutionVideo?.defaultPlayer ?? resolutionVideo?.player ?? 'sambatech'
  );
};

const getVideoToken = (
  playerType: PlayerType,
  resolutionVideo: IVideo
): string => {
  const token = playerType === 'vimeo' && resolutionVideo.vimeoID
  ? resolutionVideo.vimeoID
  : playerType === 'sambatech' && resolutionVideo?.sambatech_token
    ? resolutionVideo.sambatech_token
    : playerType === 'youtube' && resolutionVideo?.youtubeUrl
      ? resolutionVideo.youtubeUrl
      : '';

  return token === '0' ? '' : token;
};
